// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const linkedAccounts = "LinkedAccounts__linkedAccounts__tAYLt";
export const subtitle = "LinkedAccounts__subtitle__uSLho";
export const linkedAccountList = "LinkedAccounts__linkedAccountList__puyXm";
export const linkedAccountListItem = "LinkedAccounts__linkedAccountListItem__HKe-n";
export const header = "LinkedAccounts__header__GzlWA";
export const filters = "LinkedAccounts__filters__32Si4";
export const selectedFilter = "LinkedAccounts__selectedFilter__3pTd6";